import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';

export const SearchPage = {
    components: {

    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        submitSearchForm(e){

            $('.js-search-tabs').removeClass('is-active');
            $('.js-search-tabs[data-tab-active="products"]').addClass('is-active');

            VplRouter('/poisk/?q=' + $(this.$el).find('.js-search-page-input').val(), e, false);
        }
    },
    updated(){

    },
    mounted(){
        $(this.$el).find('.js-search-clear').click( () => {
            $(this.$el).find('.js-search-page-input').val('');
        });
    },
    computed: {
        ...mapState(vplSiteStore, ['struct'])
    },
    template: `
<section class="search-page">
    <div class="container">
        <form action="" @submit.prevent="this.submitSearchForm()" method="get">
            <div class="search-page__container js-search-page-container">
                <input type="text" placeholder="поиск..." name="q" :value="this.struct[this.structKey].componentData.REQUEST" class="search-page__input js-search-page-input">
                <a href="#" class="search-page__container-clear js-search-clear">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                </a>
            </div>
            <button type="submit" class="btn btn--green">Найти</button>
        </form>
    </div>
</section>
    `
}